import { CellContext } from '@tanstack/react-table';
import { useMemo } from 'react';
import get from 'lodash/get';
import { ArrayPoint } from '../../../cartesian';
import { SparklineCellRenderer } from '../../../cartesian/SparklineCellRenderer';
import { toNumber } from '../number/utils';
import { Timeseries } from './models';

export const TimeseriesCellRenderer = <TData, TValue>(props: CellContext<TData, TValue>): JSX.Element => {
  const { column, row, getValue } = props;
  const value = get(row.original, column.id) as Timeseries[];

  const isValueFormatterEnabled = column.columnDef.meta?.valueFormatter?.enabled;
  const isValueArray = Array.isArray(value);
  const hasInvalidTimestamps = isValueArray && value.length > 0 && !('timestamp' in value[0]);
  const shouldRenderDefault = !isValueFormatterEnabled || !isValueArray || hasInvalidTimestamps;

  if (shouldRenderDefault) {
    const displayValue = value != null ? JSON.stringify(value, null, 2) : '—';
    return <div>{displayValue}</div>;
  }

  const data: ArrayPoint[] =
    value?.map(({ timestamp, ...values }) => [Date.parse(timestamp), ...Object.values(values)] as ArrayPoint) ?? [];
  const summaryValue = getValue() != null ? toNumber(getValue()) : null;
  const summaryDisplayValue = summaryValue != null ? summaryValue : undefined;

  return (
    <SparklineCellRenderer
      data={data as ArrayPoint[]}
      summaryValue={summaryDisplayValue}
      {...column.columnDef.meta?.cellTypeOptions}
    />
  );
};
